import moment from 'moment';
import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import DatePicker from '../../../../components/common/DatePicker';

interface VasRangesProps {

    searchParams: any
    toggleSelections: Function
    appendParams: Function
    PurchaseDate: boolean
    RegistrationExpiration: boolean
    LeaseExpiration: boolean
    DispositionDate: boolean
    isChrome: boolean
}

type VasRangesTypes = {
    startDate: any
    endDate: any
}

class VasRanges extends Component<VasRangesProps, VasRangesTypes> {

    timeFormat = "YYYY-MM-DD HH:mm:ss"
    regOptions = ["PurchaseDate", "RegistrationExpiration", "LeaseExpiration", "DispositionDate"]

    state = {
        startDate: "",
        endDate: ""
    }

    componentDidMount() {
        let param: any = this.props.searchParams
        this.setState({ startDate: param.StartDate, endDate: param.EndDate })
    }

    updateRegistrationRangeParams = (option: string) => {
        for (let i = 0; i < this.regOptions.length; i++) {
            if (option.split("-")[0] === this.regOptions[i].split("-")[0]) {
                this.regOptions[i] = option
            } else {
                this.regOptions[i] = this.regOptions[i].split("-")[0] + "-f"
            }
        }
        this.props.toggleSelections(this.regOptions)
        if (option.split("-")[1] === "f") {
            this.props.appendParams([{ DateRangeType: "" }])
        } else {
            this.props.appendParams([{ DateRangeType: option.split("-")[0] }])
        }
    }

    handleStartDateChange = (val: any) => {
        this.setState({ startDate: val.valueOf() })
        this.props.appendParams([{ StartDate: moment(val.valueOf()).format(this.timeFormat) }])
    }

    handleEndDateChange = (val: any) => {
        this.setState({ endDate: val.valueOf() })
        this.props.appendParams([{ EndDate: moment(val.valueOf()).format(this.timeFormat) }])
    }

    clearStartDate = () => {
        this.setState({ startDate: "" })
    }

    clearEndDate = () => {
        this.setState({ endDate: "" })
    }

    render() {

        return (
            <div className="VasRanges">
                <div className="VasRangesRegInfoWrapper">
                    <div className="VasRangesLeftPanel">
                        <div className="VasRangesBtnsTop">
                            <div id="vas-ranges-btn-purchase-date">
                                {!this.props.PurchaseDate &&
                                    <Button onClick={() => this.updateRegistrationRangeParams("PurchaseDate-t")} tabIndex={-1} >
                                        <div id="vas-inspections-maintenance-btn-content-wrapper">
                                            {this.props.isChrome && <input id="fleet-chrome-radio" type="checkbox" tabIndex={-1} onClick={() => this.updateRegistrationRangeParams("PurchaseDate-t")}></input>}
                                            {!this.props.isChrome && <input id="fleet-fox-radio" type="checkbox" tabIndex={-1} onClick={() => this.updateRegistrationRangeParams("PurchaseDate-t")}></input>}
                                            <p>Purchased</p>
                                        </div>
                                    </Button>}
                                {this.props.PurchaseDate && <Button id="vas-ranges-clear" onClick={() => this.updateRegistrationRangeParams("PurchaseDate-f")} tabIndex={-1}>
                                    <div id="vas-inspections-maintenance-btn-content-wrapper">
                                        {this.props.isChrome && <input id="fleet-chrome-radio" type="checkbox" tabIndex={-1} defaultChecked onClick={() => this.updateRegistrationRangeParams("PurchaseDate-f")}></input>}
                                        {!this.props.isChrome && <input id="fleet-fox-radio" type="checkbox" tabIndex={-1} defaultChecked onClick={() => this.updateRegistrationRangeParams("PurchaseDate-f")}></input>}
                                        <p>Purchased</p>
                                    </div>
                                </Button>}
                            </div>
                            <div id="vas-ranges-btn-reg-exp" >
                                {!this.props.RegistrationExpiration &&
                                    <Button onClick={() => this.updateRegistrationRangeParams("RegistrationExpiration-t")} tabIndex={-1}>
                                        <div id="vas-inspections-maintenance-btn-content-wrapper">
                                            {this.props.isChrome && <input id="fleet-chrome-radio" type="checkbox" tabIndex={-1} onClick={() => this.updateRegistrationRangeParams("RegistrationExpiration-t")}></input>}
                                            {!this.props.isChrome && <input id="fleet-fox-radio" type="checkbox" tabIndex={-1} onClick={() => this.updateRegistrationRangeParams("RegistrationExpiration-t")}></input>}
                                            <p>Registered</p>
                                        </div>
                                    </Button>}
                                {this.props.RegistrationExpiration && <Button id="vas-ranges-clear" onClick={() => this.updateRegistrationRangeParams("RegistrationExpiration-f")} tabIndex={-1}>
                                    <div id="vas-inspections-maintenance-btn-content-wrapper">
                                        {this.props.isChrome && <input id="fleet-chrome-radio" type="checkbox" tabIndex={-1} defaultChecked onClick={() => this.updateRegistrationRangeParams("RegistrationExpiration-f")}></input>}
                                        {!this.props.isChrome && <input id="fleet-fox-radio" type="checkbox" tabIndex={-1} defaultChecked onClick={() => this.updateRegistrationRangeParams("RegistrationExpiration-f")}></input>}
                                        <p>Registered</p>
                                    </div>
                                </Button>}
                            </div>
                        </div>
                        <div className="VasRangesBtnsMid">
                            <div id="vas-ranges-btn-purchase-date">
                                {!this.props.LeaseExpiration &&
                                    <Button onClick={() => this.updateRegistrationRangeParams("LeaseExpiration-t")} tabIndex={-1}>
                                        <div id="vas-inspections-maintenance-btn-content-wrapper">
                                            {this.props.isChrome && <input id="fleet-chrome-radio" type="checkbox" tabIndex={-1} onClick={() => this.updateRegistrationRangeParams("LeaseExpiration-t")}></input>}
                                            {!this.props.isChrome && <input id="fleet-fox-radio" type="checkbox" tabIndex={-1} onClick={() => this.updateRegistrationRangeParams("LeaseExpiration-t")}></input>}
                                            <p>Lease Exp</p>
                                        </div>
                                    </Button>}
                                {this.props.LeaseExpiration && <Button id="vas-ranges-clear" onClick={() => this.updateRegistrationRangeParams("LeaseExpiration-f")} tabIndex={-1}>
                                    <div id="vas-inspections-maintenance-btn-content-wrapper">
                                        {this.props.isChrome && <input id="fleet-chrome-radio" type="checkbox" tabIndex={-1} defaultChecked onClick={() => this.updateRegistrationRangeParams("LeaseExpiration-f")}></input>}
                                        {!this.props.isChrome && <input id="fleet-fox-radio" type="checkbox" tabIndex={-1} defaultChecked onClick={() => this.updateRegistrationRangeParams("LeaseExpiration-f")}></input>}
                                        <p>Lease Exp</p>
                                    </div>
                                </Button>}
                            </div>
                            <div id="vas-ranges-btn-purchase-date">
                                {!this.props.DispositionDate &&
                                    <Button onClick={() => this.updateRegistrationRangeParams("DispositionDate-t")} tabIndex={-1}>
                                        <div id="vas-inspections-maintenance-btn-content-wrapper">
                                            {this.props.isChrome && <input id="fleet-chrome-radio" type="checkbox" tabIndex={-1} onClick={() => this.updateRegistrationRangeParams("DispositionDate-t")}></input>}
                                            {!this.props.isChrome && <input id="fleet-fox-radio" type="checkbox" tabIndex={-1} onClick={() => this.updateRegistrationRangeParams("DispositionDate-t")}></input>}
                                            <p>Dispositioned</p>
                                        </div>
                                    </Button>}
                                {this.props.DispositionDate && <Button id="vas-ranges-clear" onClick={() => this.updateRegistrationRangeParams("DispositionDate-f")} tabIndex={-1}>
                                    <div id="vas-inspections-maintenance-btn-content-wrapper">
                                        {this.props.isChrome && <input id="fleet-chrome-radio" type="checkbox" tabIndex={-1} defaultChecked onClick={() => this.updateRegistrationRangeParams("DispositionDate-f")}></input>}
                                        {!this.props.isChrome && <input id="fleet-fox-radio" type="checkbox" tabIndex={-1} defaultChecked onClick={() => this.updateRegistrationRangeParams("DispositionDate-f")}></input>}
                                        <p>Dispositioned</p>
                                    </div>
                                </Button>}
                            </div>
                        </div>
                    </div>
                    <div className="VasRangesRightPanel">
                        <div id="vas-ranges-start-date">
                            <p id="vas-date-start" onClick={this.clearStartDate}>Start</p>
                            <DatePicker value={this.state.startDate} onChange={this.handleStartDateChange} type="input" useCloseCallback />
                        </div>
                        <div id="vas-ranges-end-date" tabIndex={-1}>
                            <p id="vas-date-end" onClick={this.clearEndDate}>End</p>
                            <DatePicker value={this.state.endDate} onChange={this.handleEndDateChange} type="input" useCloseCallback />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default VasRanges